import {sum} from "@pg-mono/nodash";

export const getWeightedRandomIndex = (weights: number[]) => {
    if (weights.some((weight) => weight < 0 || weight > 1)) {
        throw new Error(`Weights must be between 0 and 1. Weights: ${weights}`);
    }

    if (sum(weights) !== 1) {
        throw new Error("Weights must sum to 1");
    }

    const cumulative = weights.map(
        (
            (sum) => (weight) =>
                (sum += weight)
        )(0)
    );

    const random = Math.random();
    return cumulative.findIndex((weight) => random <= weight);
};
import {sum} from "@pg-mono/nodash";

export const getWeightedRandomIndex = (weights: number[]) => {
    if (weights.some((weight) => weight < 0 || weight > 1)) {
        throw new Error(`Weights must be between 0 and 1. Weights: ${weights}`);
    }

    if (sum(weights) !== 1) {
        throw new Error("Weights must sum to 1");
    }

    const cumulative = weights.map(
        (
            (sum) => (weight) =>
                (sum += weight)
        )(0)
    );

    const random = Math.random();
    return cumulative.findIndex((weight) => random <= weight);
};
